RivalIQ.apps.SocialPosts.module('curations', function (curations, App, Backbone, Marionette, $, _, moment, s) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const MAX_URL_LENGTH = 25;

    const DETECT_SCROLL_MS = 5000;
    const MIN_PAGE_VIEWED_PCT = 0.05;

    function sendViewedMetric(curation, channel) {
        if (!curation.socialPostMetricSent) {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedSocialPostsReal, {
                channel: channel
            });
            curation.socialPostMetricSent = true;
            $(window).unbind('scroll');
            clearTimeout($.data(window, 'pageViewTimer'));
        }
    }

    function getConfig() {

        return [
            {
                name: 'top',
                sizes: {
                    md: 12
                },
                page: 0
            },
            {
                name: 'posts',
                sizes: {
                    md: 12
                },
                page: 0
            },
            [
                {
                    name: 'middle-left',
                    className: 'x-normalize-heights',
                    sizes: {
                        md: 6,
                        sm: 12
                    },
                    page: 1
                },
                {
                    name: 'trends',
                    className: 'x-normalize-heights',
                    sizes: {
                        md: 6,
                        sm: 12
                    },
                    page: 2
                }
            ],
            [
                {
                    name: 'keywords',
                    className: 'x-normalize-heights',
                    sizes: {
                        md: 6,
                        sm: 12
                    },
                    page: 3
                },
                {
                    name: 'hashtags',
                    className: 'x-normalize-heights',
                    sizes: {
                        md: 6,
                        sm: 12
                    },
                    page: 3
                }
            ],
            {
                name: 'boosted-posts',
                sizes: {
                    md: 12
                },
                page: 4
            },
            {
                name: 'post-tags',
                sizes: {
                    md: 12
                },
                page: 5
            },
            {
                name: 'dimensions',
                sizes: {
                    md: 12
                },
                page: 5
            },
            {
                name: 'time-usage',
                sizes: {
                    md: 12
                },
                page: 6
            }
        ];
    }

    const SocialPostsLayoutMixin = curations._socialPostsLayoutMixin = {

        loadData: function (cb) {
            const me = this;

            const curation = _.get(me.dashboardModel, ['curation'], me.dashboardModel);
            let concept = RivalIQ.metrics.descriptions.SOCIAL_POSTS.id;
            if (curation.id === RivalIQ.enums.curation.POSTED_URLS) {
                concept = RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id;
            }
            const definition = new RivalIQ.models.MetricDefinition({
                concept: concept
            });
            App.utils.updateMetric(definition, me.getProps());

            const fetches = [
                definition.fetch(),
                RivalIQ.postTags.data.PostTags.fetch()
            ];

            me._nonBlockingLoad = $.when.apply($, fetches)
                .then(function (metric, postTags) {
                    me.postTags = postTags;
                    me.metric = metric;
                    me.hasPosts = (metric.getValue({
                        format: false
                    }) > 0);

                    // reset to ignore any previous error
                    me.error = null;
                    me.errorName = null;
                    const curation = me.dashboardModel.curation || me.dashboardModel;
                    if (curation.showTour && me.hasPosts) {
                        curation.showTour();
                    }
                })
                .fail(function (xhr) {
                    me.metric = null;
                    me.hasPosts = null;
                    me.error = xhr;
                    me.errorName = _.get(xhr, ['errorName'], xhr.status);

                    me.requestRenderedFrame(function () {
                        _.result(me, '_handleError');
                    });
                });

            // Call this callback immediately so that the child widgets will be rendered and their metric requests will be in
            // the same batch as this loadData. See #34843
            cb();
        }
    };

    const debouncedReload = _.debounce(function (view) {
        view.reload();
    });

    const SocialPostsLayout = curations.Layout = Dashboard.views.CurationLayout.mixin({
        className: 'flex-toolbar-layout',
        template: '#dashboardSocialPostsLayoutTemplate',
        getConfig: getConfig,
        regions: {
            regionContainer: '.dashboard-regions',
            actions: {
                selector: '.x-toolbar-actions-region',
                regionClass: RivalIQ.regions.ListRegion
            },
            leftActions: '.x-left-actions-region',
            historyLimit: '.x-history-limit'
        },
        ui: {
            noPosts: '.no-posts',
            widgets: '.dashboard-regions'
        },
        mixins: {
            SocialPostsLayout: SocialPostsLayoutMixin,
            SearchableLayout: RivalIQ.apps.Dashboard.mixins.SearchableLayout,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },
        dashboardModelEvents: {
            // need to debounce this as it's possible that we'll get called with several changes in rapid succession. See #18397
            'change': 'debouncedReload'
        },

        debouncedReload: function () {
            const me = this;
            debouncedReload(me);
        },

        onRenderLoaded: function () {
            const me = this;

            me.showToolbars();
            me.toggleView();
        },

        _handleError: function () {
            const me = this;
            if (me.error) {
                me.historyLimit.$el.hide();
                const errorName = me.error.errorName || me.error.name;
                const hideTryAgain = _.includes(['SearchQueryTooLongError', 'InvalidDateError'], errorName);
                me.showTryAgainMessage(me.getMessageForError(me.error), hideTryAgain);
                me.ui.widgets.hide();
            }
        },

        toggleView: function () {
            const me = this;
            const searchedForInstagramMention = (me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) && _.startsWith(me.getProp('searchTerm'), '@');

            me._nonBlockingLoad
                .then(() => {
                    me.requestRenderedFrame(function () {
                        // TODO front load before requesting data
                        if (overHistoryLimit(me.getProp('timePeriod'))) {
                            me.historyLimit.show(new App.views.HistoryLimit());
                            me.ui.noPosts.hide();
                            me.ui.widgets.hide();
                        } else if (me.error) {
                            me._handleError();
                        } else if (searchedForInstagramMention) {
                            me.historyLimit.$el.hide();
                            if (_.startsWith(me.getProp('searchTerm'), '@*')) {
                                me.showTryAgainMessage('Searching for mentions in Instagram posts using @* is not supported. Their API no <br> longer displays @ symbols to signify mentions in a caption.');
                            } else {
                                me.showTryAgainMessage('On Instagram, try searching for mentions using just the handle name (exclude the @). <br> Their API no longer displays @ symbols to signify mentions in a caption.');
                            }
                            me.ui.widgets.hide();
                        } else if (!me.hasPosts) {
                            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
                            me.showTryAgainMessage(`There were no matching ${postWord}s in your landscape.`);
                            me.ui.widgets.hide();
                        } else {
                            me.historyLimit.$el.hide();
                            me.ui.noPosts.hide();
                            me.ui.widgets.show();
                        }
                    });
                });
        },

        refresh: function () {
            const me = this;
            me.toggleView();
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            me.leftActions.show(new App.views.Search({
                dashboardModel: me.dashboardModel,
                companyData: me.dashboardModel.companyData
            }));
        }
    });

    const ExportLayout = Dashboard.views.ExportWidgets.mixin({
        template: '#socialPostsExportWidgetsTemplate',
        mixins: {
            SocialPostsLayout: SocialPostsLayoutMixin
        },
        ui: {
            widgets: '.x-widgets-region',
            noPosts: '.no-posts'
        },
        onRenderLoaded: function () {
            const me = this;

            me._nonBlockingLoad
                .then(() => {

                    if (me.metric.getValue({
                        format: false
                    }) === 0) {
                        me.ui.widgets.hide();
                        me.ui.noPosts.show();
                    } else {
                        me.ui.widgets.show();
                        me.ui.noPosts.hide();
                    }
                });
        },
        getConfig: getConfig
    });

    const SocialPostDetailsLayout = curations.SocialPostDetailsLayout = Dashboard.views.DetailsLayout.mixin({
        template: '#dashboardSocialPostsDetailsLayoutTemplate',
        className: 'flex-toolbar-layout details',
        mixins: {
            SocialPostsLayout: SocialPostsLayoutMixin,
            SearchableLayout: RivalIQ.apps.Dashboard.mixins.SearchableLayout
        },

        onBeforeShow: _.noop,

        ui: {
            autoTagRules: '.x-auto-tag-rules'
        },

        events: {
            'click @ui.autoTagRules': 'onShowAutoTagRules'
        },

        dashboardModelEvents: {
            // NOTE this is aggressive because we need to `reload` so that the
            // apparatus for displaying search errors will appropriately execute
            'change:searchTerm': 'reload'
        },

        _onRenderLoadedWithMetric: function () {
            const me = this;

            if (!me.metric) {
                const hideTryAgain = _.includes(['SearchQueryTooLongError', 'InvalidDateError'], me.errorName);
                return me.showTryAgainMessage(me.getMessageForError(me.errorName), hideTryAgain);
            }

            RivalIQ.apps.Dashboard.utils.execWithBuffering(function () {
                const View = me.getBodyView();
                me.body.show(new View({
                    dashboardModel: me.dashboardModel
                }));
            });
        },

        onRenderLoaded: function () {
            const me = this;

            me.showLeftToolbarActions();
            me.showToolbarActions();

            if (me._nonBlockingLoad) {
                me._nonBlockingLoad
                    .then(() => {
                        me.requestRenderedFrame(() => {
                            me._onRenderLoadedWithMetric();
                        });
                    });
            } else {
                me._onRenderLoadedWithMetric();
            }
        },

        onShowAutoTagRules: function () {
            const me = this;

            const postTagsById = _.keyBy(me.postTags, 'id');
            const modal = new RivalIQ.postTags.views.AutoTagRuleModal({
                socialPostSearchTerm: '',
                autoTagModel: me.dashboardModel,
                postTagsById: postTagsById
            });

            RivalIQ.execute('show:modal', modal);
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.OpenedAutoTagRuleModal);
        },

        showLeftToolbarActions: function () {
            const me = this;

            me.showBackLink();
            me.leftActions.show(new App.views.Search({
                dashboardModel: me.dashboardModel,
                companyData: me.dashboardModel.curation.companyData
            }), {
                preventDestroy: true
            });
        },

        showTryAgainMessage: function (message, hideTryAgain) {
            const me = this;
            const View = me.getSearchableErrorView();
            const view = new View({
                model: new Backbone.Model({
                    message: message,
                    hideTryAgain: hideTryAgain
                })
            });
            me.body.show(view);
        }
    });

    function overHistoryLimit(timePeriod) {
        const requestedHistoryDays = moment.utc().diff(timePeriod.mainPeriodStart, 'days');
        const allowedHistoryDays = RivalIQ.state.account.get('historyLimits').mainPeriod;
        return requestedHistoryDays > allowedHistoryDays;
    }

    curations.SocialPosts = Dashboard.models.Curation.mixin({
        mixins: {
            ChannelSwitchable: Dashboard.mixins.ChannelSwitchable,
            CurationBufferedEventProxy: Dashboard.mixins.CurationBufferedEventProxy,
            postTagManagerEventing: RivalIQ.postTags.mixins.PostTagsEventingMixin
        },

        beforeFilters: [
            Dashboard.curations.filters.channelWall,
            curations.filters.loadCompanyData,
            curations.filters.loadPostTags
        ],

        afterFilters: [
            function (curation) {
                if (curation.id === RivalIQ.enums.curation.SOCIALPOSTS) {
                    const channel = curation.getProp('channel') || 'cross_channel';
                    // views tab for longer than DETECT_SCROLL_MS ms
                    $.data(window, 'pageViewTimer', setTimeout(function () {
                        sendViewedMetric(curation, channel);
                    }, DETECT_SCROLL_MS));

                    // OR scrolls past MIN_PAGE_VIEWED_PCT % of page
                    const windowEvents = $._data(window, 'events');
                    const hasScroll = _.get(windowEvents, 'scroll');
                    if (!hasScroll) {
                        $(window).scroll(function (e) {
                            const postContainer = $('.post-container');
                            const pctDownPage = postContainer.length ? document.documentElement.scrollTop / postContainer[0].clientHeight : 0;
                            if (pctDownPage > MIN_PAGE_VIEWED_PCT) {
                                sendViewedMetric(curation, channel);
                            }
                        });
                    }
                }
            }
        ],

        postTagManagerEvents: {
            'postTag:created': 'onPostTagCreated',
            'postTag:changed': 'onPostTagChanged',
            'postTag:deleted': 'onPostTagDeleted'
        },

        onPostTagCreated: function (postTag) {
            const me = this;

            const index = _.findIndex(me.postTags, {
                id: postTag.get('id')
            });

            if (index === -1) {
                me.postTags.push(postTag.attributes);
            } else {
                me.postTags[index] = postTag.attributes;
            }
        },

        onPostTagChanged: function (postTag) {
            const me = this;

            if (me.postTags) {
                const index = _.findIndex(me.postTags, {
                    id: postTag.get('id')
                });
                me.postTags[index] = postTag.attributes;
            }
        },

        onPostTagDeleted: function (postTag) {
            const me = this;

            if (me.postTags) {
                const postTagId = postTag.get('id');
                _.remove(me.postTags, function (tag) {
                    return tag.id === postTagId;
                });
            }
        },

        getCurationId: function () {
            const me = this;
            return s.dasherize([me.id.toLowerCase(), me.getProp('channel')].join('-'));
        },

        loadConfiguration: function () {
            const me = this;
            return RivalIQ.data.configuration.fetch(me, me.getProps());
        },

        getBackLinkName: _.constant(),
        getBackLinkClassName: _.constant('btn btn-default btn-back-link'),

        getBackPath: function (widgetProps) {
            const me = this;
            const props = _.omit(_.pick(widgetProps, me.validCurationOptions), 'instanceId', 'widgetId');
            return me.getBasePath(props);
        },

        getPath: function (overrides) {
            const me = this;

            let props = _.extend({}, me.getProps(), overrides);

            if (props.instanceId || props.widgetId) {
                props = _.pick(props, me.validWidgetOptions);
            } else {
                props = _.pick(props, me.validCurationOptions);
            }

            _.each(_.keys(RivalIQ.enums.searchFieldNames), function (searchFieldName) {
                if (_.get(props, [searchFieldName]) === '') {
                    props = _.omit(props, searchFieldName);
                }
            });

            return me.getBasePath(props);
        },

        parseParams: function (params) {
            const me = this;
            const parsed = RivalIQ.apps.Dashboard.models.Curation.prototype.parseParams.call(me, params);

            return RivalIQ.utils.queryParams.forceSearchParamsToString(parsed, RivalIQ.enums.searchFieldNames);
        },

        getExportSubtitle: function () {
            const me = this;

            const subtitleParts = [];

            const searchTerm = me.getProp('searchTerm');
            if (searchTerm) {
                subtitleParts.push(`Query: "${_.escape(searchTerm)}"`);
            }

            const canonicalUrlFilter = me.getProp('canonicalUrlFilter');
            if (canonicalUrlFilter) {
                subtitleParts.push(`Url: "${s.truncate(_.escape(canonicalUrlFilter), MAX_URL_LENGTH)}"`);
            }

            const type = me.getProp('type');
            if (type) {
                const typeName = _.get(RivalIQ.enums.postTypes, [type, 'format'], type);
                subtitleParts.push(`Post Type: ${_.escape(typeName)}`);
            }

            const postTagIds = RivalIQ.postTags.utils.getPostTagIds(me.getProp('postTagIds'));
            if (!_.isEmpty(postTagIds)) {
                subtitleParts.push(App.utils.makePostTagsText(postTagIds, me.postTags, null, me));
            }

            const periodStart = me.getProp('timePeriod').mainPeriodStart;
            const companiesWithIncompleteData = App.utils.findCompaniesWithIncompleteData(me.companyData, me.getProp('channel'), periodStart);
            if (!_.isEmpty(companiesWithIncompleteData)) {
                subtitleParts.push('(Incomplete data for some companies)');
            }

            return subtitleParts;
        },

        validWidgetOptions: App.utils.validWidgetOptions,
        validCurationOptions: App.utils.validCurationOptions,
        title: 'Social Posts',
        getExportTitle: function () {
            const me = this;
            const channel = RivalIQ.props.getChannel(me.getProps());

            const title = _.result(me, 'title');

            if (channel.isCrossChannel()) {
                return title;
            }

            return [channel.get('name'), title].join(' ');
        },
        widgetsView: SocialPostsLayout,
        pngWidgetsView: ExportLayout,
        pdfWidgetsView: ExportLayout,
        widgetView: SocialPostDetailsLayout,

        getChannels: function () {
            return RivalIQ.data.channels.withSearch().notHidden();
        },

        getChannelPathOptions: function () {
            const me = this;
            const baseOptions = Dashboard.mixins.ChannelSwitchable.getChannelPathOptions.apply(me, arguments);

            let layout;
            const widget = me.widgets.first();
            if (!me.isFocus() && widget) {
                layout = widget.getProp('layout');
            }

            return _.extend({
                tweetType: undefined,
                promotedPosts: undefined,
                domainModeFilter: undefined,
                limit: (me.isFocus() ? undefined : -1),
                layout: layout
            }, baseOptions);
        },

        getViewTrackingOptions: function () {
            const me = this;

            const viewTracking = Dashboard.models.Curation.prototype.getViewTrackingOptions.apply(me, arguments);
            if (me.isFocus()) {
                viewTracking.ref = me.getProp('ref');
            }

            return viewTracking;
        }
    });

}, window.moment, window.s);
